export default __webpack_public_path__ + "static/media/notificationBlank.d7df401c.svg";